import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { postSaveContractEndpoint } from '../../../common/endpoints';

export const postSaveContractData = createApi(postSaveContractEndpoint, 'POST');

const SaveContracts = createSlice({
  name: 'SaveContracts',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postSaveContractData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postSaveContractData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postSaveContractData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default SaveContracts.reducer;